import {
  Box,
  Container,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import React from "react";

export default function RemoteSupportSelect({
  remoteSupport,
  setRemoteSupport,
}: {
  remoteSupport: string;
  setRemoteSupport: React.Dispatch<React.SetStateAction<string>>;
}) {
  return (
    <Box className="section-50" component={"section"}>
      <Container className="container">
        <Typography component={"h2"} className="section-heading">
          【任意】遠隔でのサポートについて
        </Typography>
        <Grid container alignItems="center" spacing={2}>
          <Grid item sm={12} style={{ flex: 1 }}>
            <FormControl variant="outlined" style={{ width: "100%" }}>
              <InputLabel id="device-select">
                遠隔でのサポートについて
              </InputLabel>
              <Select
                labelId="device-select"
                id="device-select"
                value={remoteSupport}
                onChange={(e) => setRemoteSupport(e.target.value as string)}
                style={{ width: "100%" }}
                label="遠隔でのサポートについて"
              >
                <MenuItem value={"希望する"}>希望する</MenuItem>
                <MenuItem value={"希望しない"}>希望しない</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
